import React, { useState, useEffect } from "react";
import "./App.css";

const Increase = () => {
  // const storedDarkMode = localStorage.getItem("DARK_MODE");
  // const [darkMode, setDarkMode] = useState(storedDarkMode);
  // const toggleDarkMode = () => setDarkMode(darkMode ? false : true);

  // useEffect(() => {
  //   localStorage.setItem("DARK_MODE", darkMode);
  // }, [darkMode]);

  const initial1 = Number(window.localStorage.getItem("increment1") || 0);
  const [increment1, add1] = useState(initial1);

  useEffect(() => {
    document.title = `Baby Retriever : ${increment1} 💙 `;
    window.localStorage.setItem("increment1", increment1);
  }, [increment1]);
  // ----------------------------------------

  const initial2 = () => Number(window.localStorage.getItem("increment2") || 0);
  const [increment2, add2] = useState(initial2);

  useEffect(() => {
    document.title = `Siberian Husky: ${increment2} 💙`;
    window.localStorage.setItem("increment2", increment2);
  }, [increment2]);

  // --------------------------------------------

  const initial3 = () => Number(window.localStorage.getItem("increment3") || 0);
  const [increment3, add3] = useState(initial3);

  useEffect(() => {
    document.title = `Staffordshire Bull Terrier: ${increment3} 💙`;
    window.localStorage.setItem("increment3", increment3);
  }, [increment3]);

  // ---------------------------------------

  const initial4 = () => Number(window.localStorage.getItem("increment4") || 0);
  const [increment4, add4] = useState(initial4);

  useEffect(() => {
    document.title = `Daschund: ${increment4} 💙`;
    window.localStorage.setItem("increment4", increment4);
  }, [increment4]);

  // --------------------------------------

  const initial5 = () => Number(window.localStorage.getItem("increment5") || 0);
  const [increment5, add5] = useState(initial5);

  useEffect(() => {
    document.title = `Pug: ${increment5} 💙`;
    window.localStorage.setItem("increment5", increment5);
  }, [increment5]);

  // -----------------------------------------

  const initial6 = () => Number(window.localStorage.getItem("increment6") || 0);
  const [increment6, add6] = useState(initial6);

  useEffect(() => {
    document.title = `Rottweiler: ${increment6} 💙`;
    window.localStorage.setItem("increment6", increment6);
  }, [increment6]);

  // ------------------------------------------------

  const initial7 = () => Number(window.localStorage.getItem("increment7") || 0);
  const [increment7, add7] = useState(initial7);

  useEffect(() => {
    document.title = `Bulldog: ${increment7} 💙`;
    window.localStorage.setItem("increment7", increment7);
  }, [increment7]);

  // ------------------------------------------------

  const initial8 = () => Number(window.localStorage.getItem("increment8") || 0);
  const [increment8, add8] = useState(initial8);

  useEffect(() => {
    document.title = `German Sheperd: ${increment8} 💙`;
    window.localStorage.setItem("increment8", increment8);
  }, [increment8]);

  // ------------------------------------------------

  // const initial9 = () => Number(window.localStorage.getItem("increment9") || 0);
  // const [increment9, add9] = useState(initial9);

  // useEffect(() => {
  //   document.title = `Chihauhua: ${increment9} 💙`;
  //   window.localStorage.setItem("increment9", increment9);
  // }, [increment9]);

  //   const initial9 = () => Number(window.localStorage.getItem("increment9") || 0);
  //   const [increment9, add9] = useState(initial9);

  //   useEffect(() => {
  //     document.title = `Golden Retriever: ${increment9} 💙`;
  //     window.localStorage.setItem("increment9", increment9);
  //   }, [increment9]);
  // data-theme={darkMode ? "dark" : "light"}
  // ------------------------------------------------
  return (
    <div>
      <div className="name">
        <p>
          <img
            src="https://image.flaticon.com/icons/png/512/2064/2064863.png"
            height="40px"
            alt="favicon"
          />
          InstDOGram
        </p>
      </div>
      {/* <button onClick={toggleDarkMode}> {darkMode ? "Dark" : "Light"}</button> */}
      <div className="clearN">
        <h3>InstDOGram</h3>
      </div>

      <div className="post">
        <div className="dog1"></div>
        <h2>{increment1} 💙</h2>
        <div className="like">
          <button onClick={() => add1(increment1 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">
          <i>#Lol- Baby Retriever sleeping!!</i>
        </div>
      </div>

      <div className="post">
        <div className="dog2">
          {/* <img
            src={"./Assets/Posts/Snaps/huskyforest.jpg"}
            height="300px"
            width="300px"
          /> */}
        </div>
        <h2>{increment2} 💙</h2>
        <div className="like">
          <button onClick={() => add2(increment2 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">
          <i>So smart, so cool</i>
        </div>
      </div>

      <div className="post">
        <div className="dog3"></div>
        <h2>{increment3} 💙</h2>
        <div className="like">
          <button onClick={() => add3(increment3 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>

      <div className="post">
        <div className="dog4"></div>
        <h2>{increment4} 💙</h2>
        <div className="like">
          <button onClick={() => add4(increment4 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>

      <div className="post">
        <div className="dog5"></div>
        <h2>{increment5} 💙</h2>
        <div className="like">
          <button onClick={() => add5(increment5 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>

      <div className="post">
        <div className="dog6"> </div>

        <h2>{increment6} 💙</h2>
        <div className="like">
          <button onClick={() => add6(increment6 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>

      <div className="post">
        <div className="dog7"> </div>

        <h2>{increment7} 💙</h2>
        <div className="like">
          <button onClick={() => add7(increment7 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>

      <div className="post">
        <div className="dog8"></div>
        <h2>{increment8} 💙</h2>
        <div className="like">
          <button onClick={() => add8(increment8 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div>
      {/* 
      <div className="post">
        <div className="dog9"></div>
        <h2>{increment9} 💙</h2>
        <div className="like">
          <button onClick={() => add9(increment9 + 1)} classNameName="button">
            <img
              src="https://64.media.tumblr.com/816735e408de7b6a789000645bfc364d/tumblr_p447y12NS31qzm8dwo1_400.gifv"
              height="50px"
              alt="like"
            />
          </button>
        </div>
        <div className="desc">Image Description</div>
      </div> */}
      <div className="footer">
        <p>
          <img
            src="https://image.flaticon.com/icons/png/512/2064/2064863.png"
            height="40px"
            alt="favicon"
          />
          InstDOGram
        </p>
      </div>
    </div>
  );
};

export default Increase;
